import { API_REFERENCE } from '../utilities/constant_api';
import { htmlGet, formPostJsonResponse } from './ajax';

$(function() {
  let facilitySearchInputAjaxReq = true;
  let saveFacilityInputAjaxReq = true;
  let saveFacilityNotRegisteredUserAjaxReq = true;
  function selectingRow() {
    $('.search-facilities-table__radio').each(function(index, item) {
      if (
        $(item).prop('checked') &&
        $(item).attr('data-id') !== $(this).attr('data-id')
      ) {
        $(item).prop('checked', '');
        $(item)
          .parent()
          .parent()
          .removeClass('facilities-row--selected');
        return false;
      }
      return true;
    });
    $(this).prop('checked', 'checked');
    $(this)
      .parent()
      .parent()
      .addClass('facilities-row--selected');
    $('.save-btn').attr('disabled', false);
  }

  function facilitySearchInput() {
    //Disable Register button until radio button selected
    $('.register-user').attr('disabled', true);
    var facilitySearchControllerUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.facilitySearch.referralSearchFacility}`;
    var $formData = {
      state: $('#facility-state').val(),
      searchTerm: $('#findFacility').val()
    };
    $('.global-error-message-container').addClass('hidden');
    if (!facilitySearchInputAjaxReq) return false;
    facilitySearchInputAjaxReq = false;
    htmlGet(facilitySearchControllerUrl, $formData)
      .then(responseData => {
        facilitySearchInputAjaxReq = true;
        if ($(responseData).find('.facility-error-message').length > 0) {
          $('.global-error-message-container .generic-error-text').text(
            $(responseData)
              .find('.facility-error-message')
              .val()
          );
          $('.global-error-message-container').removeClass('hidden');
          window.scrollTo(0, 0);
        } else {
          const data = ACC.sanitizer.sanitizeHtmlDeeply(responseData);
          $('.select-facility').show();
          $('.select-facility').html(data);
          $('.search-result-phonenumber').text(function(i, text) {
            text = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
            return text;
          });
        }
      })
      .catch(() => {
        facilitySearchInputAjaxReq = true;
      });
  }

  function searchOnEnter(event) {
    if (event.keyCode === 13) {
      facilitySearchInput();
    }
  }

  function saveSelectedFacility() {
    var $form = $(document).find('#selectedFacilityForm');
    var isRegisteredUser = $('#isRegisteredUser').val();
    var submitUrl =
      ACC.config.encodedContextPath + '/referral/selected-facility';

    if (String(isRegisteredUser) == 'true') {
      submitUrl = ACC.config.encodedContextPath + '/referral/edit-facility';
      if (!saveFacilityInputAjaxReq) return false;
      saveFacilityInputAjaxReq = false;
      $.ajax({
        type: 'POST',
        url: submitUrl,
        data: $form.serialize(),
        dataType: 'json',
        success: function(data) {
          saveFacilityInputAjaxReq = true;
          $('#searchFacilityModal').modal('hide');
          $('.account-demographics-facility-name').text(data.facilityName);
          $('.account-demographics-contact-number').text(data.contactNum);
          $('.referral-details').removeClass('hidden');
          $('.referral-details').addClass('show');
          $('.referral-dropdown').removeClass('show');
          $('.referral-dropdown').addClass('hidden');
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          saveFacilityInputAjaxReq = true;
        }
      });
    } else {
      if (!saveFacilityNotRegisteredUserAjaxReq) return false;
      saveFacilityNotRegisteredUserAjaxReq = false;
      $.ajax({
        type: 'POST',
        url: submitUrl,
        data: $form.serialize(),
        dataType: 'json',
        success: function(data) {
          saveFacilityNotRegisteredUserAjaxReq = true;
          $('#searchFacilityModal').modal('hide');
          $('.account-demographics-facility-name').text(data.facilityName);
          $('.account-demographics-contact-number').text(data.contactNum);
          $('.account-demographics-referral-hear').text(
            $('#referralDropdown option:selected').text()
          );
          $('.referral-details').removeClass('hidden');
          $('.referral-details').addClass('show');
          $('.referral-dropdown').removeClass('show');
          $('.referral-dropdown').addClass('hidden');
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          saveFacilityNotRegisteredUserAjaxReq = true;
        }
      });
    }
  }

  function facilitySelectedForReferral() {
    var selectedRow = $(this).closest('.row');
    var facilityName = selectedRow.find('.search-result-facility-name').text();
    var contactNum = selectedRow.find('.search-result-phonenumber').text();
    var facilityState = selectedRow.find('.search-result-state').val();

    $('input[id=selectedFacilityName]').val(facilityName);
    $('input[id=selectedFacilityNumber]').val(contactNum);
    $('input[id=selectedFacilityState]').val(facilityState);
    $('#saveSelectedFacility').attr('disabled', false);
    //Enable register button if radio is selected
    $('.register-user').attr('disabled', false);
  }

  $('.search-facilities-table__radio').on('click', selectingRow);
  $(document).on('click', '.facility-name-search', facilitySearchInput);
  $('.facility-name-search').on('keyup', searchOnEnter);
  $('.findFacility_input').on('keyup', searchOnEnter);
  $('#saveSelectedFacility').on('click', saveSelectedFacility);
  $(document).on(
    'click',
    'input[name="facilityId"]',
    facilitySelectedForReferral
  );
});
